import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import VendorAssessmentQuestionnaire from "./VendorAssessmentQuestionnaire";
import { Box, Typography, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const SESSION_KEY_PREFIX = "vendor_questionnaire_submitted_";

const VendorQuestionnairePublic = () => {
  const location = useLocation();
  const [token, setToken] = useState(null);
  const [vendorName, setVendorName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get("token");
    const vendorParam = queryParams.get("vendor_name");

    if (tokenParam) {
      // Check if this token was already submitted
      const sessionKey = SESSION_KEY_PREFIX + tokenParam;
      const alreadySubmitted = sessionStorage.getItem(sessionKey);
      if (alreadySubmitted) {
        setSubmitted(true);
      } else {
        setToken(tokenParam);
      }
    }
    if (vendorParam) {
      setVendorName(vendorParam);
    }
  }, [location.search]);

  const handleSubmitSuccess = () => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get("token");
    if (tokenParam) {
      const sessionKey = SESSION_KEY_PREFIX + tokenParam;
      sessionStorage.setItem(sessionKey, "submitted");
    }
    setSubmitted(true);
  };

  // After submission, on refresh → show "Token Expired"
  if (submitted && !token) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#eeeeee",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Paper sx={{ p: 4, maxWidth: 600, textAlign: "center" }}>
          <ErrorOutlineIcon sx={{ fontSize: 60, color: "#f44336", mb: 2 }} />
          <Typography
            variant="h5"
            sx={{ fontFamily: "Lato", fontWeight: "bold", mb: 2, color: "#f44336" }}
          >
            Link Expired
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Lato", color: "#666" }}>
            This questionnaire link has already been used and is no longer valid. If you need to
            make further changes, please contact your administrator for a new link.
          </Typography>
        </Paper>
      </Box>
    );
  }

  // Right after submission → show "Sent for Approval" page
  if (submitted && token) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#eeeeee",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Paper sx={{ p: 4, maxWidth: 600, textAlign: "center" }}>
          <CheckCircleIcon sx={{ fontSize: 60, color: "#4caf50", mb: 2 }} />
          <Typography
            variant="h5"
            sx={{ fontFamily: "Lato", fontWeight: "bold", mb: 2, color: "#001b2b" }}
          >
            Sent for Approval
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Lato", color: "#666" }}>
            Your responses have been submitted for approval. You will be notified once the review is
            complete. You may now close this page.
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (!token) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#eeeeee",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Paper sx={{ p: 4, maxWidth: 600, textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontFamily: "Lato", fontWeight: "bold", mb: 2, color: "#f44336" }}>
            Invalid Access
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Lato", color: "#666" }}>
            The questionnaire link is invalid or has expired. Please contact your administrator for a new link.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <VendorAssessmentQuestionnaire
      token={token}
      vendorName={vendorName}
      onSubmitSuccess={handleSubmitSuccess}
    />
  );
};

export default VendorQuestionnairePublic;
